// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".about-padding{padding-left:20%;padding-right:20%;text-align:center}.about-container{padding-bottom:5rem;width:80rem}#face:hover{-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-name:rotateIn;animation-name:rotateIn;transform-origin:center}", ""]);
// Exports
module.exports = exports;
